// extracted by mini-css-extract-plugin
export default {"addToCart":"AddToCart_addToCart__yLAzE","add":"AddToCart_add__lLAXk"};